import getDirectGastrofyAxiosClient from '../clients/directGastrofyAxiosClient';
import type {
    ApiGastrofyDiscoveryRequest,
    ApiGastrofyResolveRequest,
} from './requests/gastrofyRequests';
import type {
    ApiGastrofyDiscoveryResponse,
    ApiGastrofyResolveResponse,
} from './responses/gastrofyResponses';

const discovery = async (
    request: ApiGastrofyDiscoveryRequest,
): Promise<ApiGastrofyDiscoveryResponse> => {
    const client = await getDirectGastrofyAxiosClient();

    const response = await client.get<ApiGastrofyDiscoveryResponse>(`api/discovery/recipes`, {
        params: request,
    });
    return response.data;
};

const resolve = async (request: ApiGastrofyResolveRequest): Promise<ApiGastrofyResolveResponse> => {
    const client = await getDirectGastrofyAxiosClient();

    const response = await client.post<ApiGastrofyResolveResponse>(
        `api/smart-cart/recipes/resolve`,
        request,
    );

    return response.data;
};

export default {
    discovery,
    resolve,
};
